import { render } from "./klb-he.vue?vue&type=template&id=f18a7c5c&scoped=true"
import script from "./klb-he.vue?vue&type=script&lang=js"
export * from "./klb-he.vue?vue&type=script&lang=js"

import "./klb-he.vue?vue&type=style&index=0&id=f18a7c5c&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f18a7c5c"]])

export default __exports__